import { zenputDb, LegacyData } from './db';

export const getDocument = async (key: string): Promise<LegacyData['data'] | undefined> => {
    const doc = await zenputDb.legacy_data.get({ legacy_id: key });

    if (doc) {
        return JSON.parse(doc.data);
    }

    return undefined;
};

export const saveDocument = async (key: string, value: object): Promise<void> => {
    const doc = await zenputDb.legacy_data.get({ legacy_id: key });

    if (doc) {
        await zenputDb.legacy_data.update(doc.id, {
            legacy_id: key,
            data: JSON.stringify(value)
        });
    } else {
        await zenputDb.legacy_data.add({
            legacy_id: key,
            data: JSON.stringify(value)
        });
    }
};

export const getKeys = async (): Promise<unknown[]> => {
    const docs = await zenputDb.legacy_data.orderBy('legacy_id').keys();
    return docs;
};

export const removeDocument = async (key: string): Promise<void> => {
    await zenputDb.legacy_data.where('legacy_id').equals(key).delete();
};
